// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBRM45YqzD-9ADUr1GIoYlzICvOaFuUMJ0",
  authDomain: "tayyab-38f7d.firebaseapp.com",
  databaseURL: "https://tayyab-38f7d-default-rtdb.firebaseio.com",
  projectId: "tayyab-38f7d",
  storageBucket: "tayyab-38f7d.firebasestorage.app",
  messagingSenderId: "228577305155",
  appId: "1:228577305155:web:29df76a1e5a9cbff94eaf6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
